import React, { FC, useCallback, useState } from 'react';
import classNames from 'classnames';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ParentsSideBar from 'components/parentsSidebar/index';
import InfoPopup from 'components/common/infoPopup/infoPopup';
import Scholars from 'pages/yourScholars/index';
import AccountSettings from 'pages/accountSettings/index';
import Referrals from 'pages/referrals/index';
import Billing from 'pages/planDetails';
import MobileService from 'services/mobile';
import Popup from 'components/common/popup/popup';
import Slider from 'components/common/slider/slider';
import LineChart from 'components/common/lineChart/lineChart';
import { LineChartTypes, PopupData } from 'types';
import styles from './styles.module.scss';

interface Props {
  isActiveSubscription: boolean;
}
const Dashboard: FC<Props> = ({ isActiveSubscription }) => {
  const match = useRouteMatch();

  const [clickedElementBox, setClickedElementBox] = useState<
    DOMRect | undefined
  >(undefined);
  const [popupIsOpened, setPopupIsOpened] = useState<boolean>(false);

  const sliderItems = [
    <LineChart
      selectedDate={new Date()}
      title="Online vs. Offline Hours of schedule activity"
      type={LineChartTypes.OnlineOfflineComparison}
    />,
    <LineChart
      selectedDate={new Date()}
      title="Activities Attended vs Activities missed"
      type={LineChartTypes.Attendance}
    />,
  ];

  const onClickedChanged = useCallback((element: HTMLElement | undefined) => {
    const box = element?.getBoundingClientRect();
    setClickedElementBox(box);
  }, []);

  const handleBtnText = useCallback((isOpen: boolean) => {
    setPopupIsOpened(isOpen);
  }, []);

  const popupData: PopupData = {
    clickedChanged: onClickedChanged,
    popupIsOpened,
  };

  return (
    <main className={classNames('container', styles.root)}>
      <ParentsSideBar />
      <div
        className={`${styles.parentsContent} ${
          MobileService.isMobile ? styles.tablet : ''
        }`}
      >
        <Switch>
          <Route key="scholars" path={`${match.path}/scholars`}>
            <Scholars
              isActiveSubscription={isActiveSubscription}
              popupData={popupData}
            />
          </Route>
          <Route key="billing" path={`${match.path}/billing`}>
            <Billing />
          </Route>
          <Route key="account-settings" path={`${match.path}/account-settings`}>
            <AccountSettings />
          </Route>
          <Route key="referrals" path={`${match.path}/referrals`}>
            <Referrals />
          </Route>
        </Switch>
      </div>
      {MobileService.isMobile && (
        <InfoPopup title="For this functionality, please use the desktop application" />
      )}
      <Popup
        elementBox={clickedElementBox}
        content={<Slider items={sliderItems} />}
        hidePopupCb={() => {
          setClickedElementBox(undefined);
          setPopupIsOpened(false);
        }}
        setBtnTextCb={handleBtnText}
      />
    </main>
  );
};

export default Dashboard;
